import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Program', prop: 'program_id', references: 'admin/programs', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Updated', prop: 'updated_at', format: 'dateWithDay' }
]

const filters = [
  { name: 'Filter by program', prop: 'filters.program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name', enabled: true }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const DisplayConfigs = (props) => (
  <List
    title='Program Display Configs'
    apiPath='admin/display_configs'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default DisplayConfigs
